/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  WhiteLabelConfig
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Returns the white-label configuration for the current domain. Uses the Origin or Referer header to detect the domain. This is used by the web app to determine which features to enable/disable.
 * @summary Get current white-label configuration
 */
export type getCurrentWhiteLabelResponse200 = {
  data: WhiteLabelConfig
  status: 200
}

export type getCurrentWhiteLabelResponseSuccess = (getCurrentWhiteLabelResponse200) & {
  headers: Headers;
};
;

export type getCurrentWhiteLabelResponse = (getCurrentWhiteLabelResponseSuccess)

export const getGetCurrentWhiteLabelUrl = () => {


  

  return `/white-labels/current`
}

export const getCurrentWhiteLabel = async ( options?: RequestInit): Promise<getCurrentWhiteLabelResponse> => {
  
  return customFetch<getCurrentWhiteLabelResponse>(getGetCurrentWhiteLabelUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

